// Rotas públicas de estoque (impressões e cotação do fornecedor).
// Migradas do submódulo f-erp-estoque (ajustes/transferencias/cotacoes/compras) para o build
// principal do f-erp, pois usam paths de raiz (/cotacao/:token, /compra/:hash,
// /transferencias_estoques/imprimir_pdf/:id, etc.) e precisam responder mesmo sem o submódulo
// estoque carregado — o SPA do módulo (modules/estoque) só atende paths sob /estoque/.
// Apenas as rotas public:true.
//
// As impressões por :id (imprimir_pdf de transferencias/ajustes/cotacoes e visualizar_compra)
// entram aqui porque o módulo as abre com :href em path de raiz (sem prefixo /estoque/),
// caindo no build principal. Só o /cotacao/:token usa componente local (../views/Cotacao);
// o resto usa os compartilhados Impressao/Visualizacao.

// ===== Redirecionamentos de rotas antigas -> modulo Estoque =====
// Muitos links e integracoes ainda apontam para as rotas planas antigas
// (ex.: /compras_produtos, /cotacoes, /ajustes_estoques). Os CRUDs migraram
// para src/modules/estoque (nucleo + submodule compras), que em producao sao
// builds SPA separados -- por isso o redirect e via location.href (recarregamento
// completo), feito pelo componente RedirecionaModulo a partir de meta.destino.
// Cada prefixo gera 2 rotas: a exata (lista) e a curinga (/*) para
// adicionar/editar/visualizar/etc.
//
// IMPORTANTE: estes redirects sao concatenados DEPOIS das rotas public:true abaixo.
// O Vue Router casa na ordem de declaracao, entao as impressoes/visualizacoes
// especificas (/compra/:hash, /compras_produtos/visualizar_compra/:id,
// /cotacoes/imprimir_pdf/:id, /ajustes_estoques/imprimir_pdf/:id,
// /transferencias_estoques/imprimir_pdf/:id, /cotacao/:token) continuam sendo
// atendidas pelo build principal e nao caem no curinga.
const RedirecionaModulo = () => import('../components/RedirecionaModulo')

const mapaRedirecionamentos = [
    // submodule compras -> /estoque/compras
    ['/compras_produtos', '/estoque/compras'],
    ['/compras_servicos', '/estoque/compras'],
    ['/compras', '/estoque/compras'],
    ['/cotacoes', '/estoque/compras'],
    ['/situacoes_compras', '/estoque/compras'],
    ['/atributos_compras', '/estoque/compras'],
    ['/relatorios_compras', '/estoque/compras'],
    // nucleo estoque -> /estoque
    ['/ajustes_estoques', '/estoque'],
    ['/transferencias_estoques', '/estoque'],
    ['/relatorios_estoque', '/estoque'],
]

const redirecionamentos = []
mapaRedirecionamentos.forEach((par) => {
    const prefixo = par[0]
    const destino = par[1]
    redirecionamentos.push({ path: prefixo, component: RedirecionaModulo, meta: { public: true, destino } })
    redirecionamentos.push({ path: prefixo + '/*', component: RedirecionaModulo, meta: { public: true, destino } })
})

const routes = [
    {
        name: 'imprimirTransferencia',
        path: '/transferencias_estoques/imprimir_pdf/:id',
        component: () => import('@/shared/components/ui/Impressao'),
        meta: {
            fullScreen: true,
            public: true
        }
    },
    {
        name: 'imprimirAjustes',
        path: '/ajustes_estoques/imprimir_pdf/:id',
        component: () => import('@/shared/components/ui/Impressao'),
        meta: {
            fullScreen: true,
            public: true
        }
    },
    {
        name: 'imprimirCotacao',
        path: '/cotacoes/imprimir_pdf/:id',
        component: () => import('@/shared/components/ui/Impressao'),
        meta: {
            fullScreen: true,
            public: true
        }
    },
    {
        name: 'imprimirCompra',
        path: '/compra/:hash',
        component: () => import('@/shared/components/ui/Impressao'),
        meta: {
            fullScreen: true,
            public: true
        }
    },
    {
        name: 'visualizarTipoCompra',
        path: '/compras_produtos/visualizar_compra/:id',
        alias: '/compras/visualizar_compra/:id',
        component: () => import('@/shared/components/ui/Visualizacao'),
        meta: {
            fullScreen: true,
            public: true
        }
    },
    {
        path: '/',
        component: () => import('@/shared/layouts/adminlte/components/Barra'),
        children: [
            {
                name: 'visualizarCotacaoFornecedor',
                path: '/cotacao/:token',
                component: () => import('../views/Cotacao'),
                meta: {
                    fullScreen: true,
                    public: true
                }
            }
        ]
    },
    // Curingas de redirect -- sempre por ultimo (ver nota no topo do arquivo)
    ...redirecionamentos
]

export default routes
